export default __webpack_public_path__ + "static/media/icon-arrow-down-red.6bedacc7.svg";